/**
 * Utility-Funktionen für Nachweis-Status und -Farben
 *
 * Einzige Quelle für die Darstellung eines Nachweis-Status. Der Status ändert sich nur über
 * die Aktionen, die der Server je Nachweis anbietet (ADR 007).
 */
import { colors } from "../../styles/colors";
import { EVIDENCE_STATUS_LABELS, EvidenceStatus } from "../../types";
import { StatusVisual } from "./statusVisual";

/** Deckende Statusfarbe – auch für Balken, Punkte und Ränder außerhalb des Chips nutzbar */
const STATUS_COLORS: Record<EvidenceStatus, string> = {
  Offen: colors.status.warning.main,
  Angefordert: colors.brand.primary,
  Erledigt: colors.status.success.main,
  // Alles zwischen Offen und Freigegeben ist „laufend“ und sieht gleich aus – unterschieden
  // wird am Label, nicht an der Farbe. So liest sich die Nachweisliste in drei Farben, wie die
  // Kacheln der Nachweise-Seite und der Balken über ihnen.
  "Angebot angefragt": colors.brand.primary,
  "Angebot erhalten": colors.brand.primary,
  Beauftragt: colors.brand.primary,
  "In Korrektur": colors.brand.primary,
  Geliefert: colors.brand.primary,
  Freigegeben: colors.status.success.main,
};

/** Deckkraft des Chip-Hintergrunds als Hex-Suffix (~9 %) */
const CHIP_BACKGROUND_ALPHA = "18";

/**
 * Ermittelt die deckende Farbe für einen gegebenen Nachweis-Status. `completed` (vom Server,
 * `Evidence.completed`) färbt den Endstatus des Bearbeitungswegs grün – „Geliefert“ ist beim
 * Anfordern abgeschlossen, beim Beauftragen folgt noch die Prüfung.
 */
export const getEvidenceStatusColor = (
  status?: string,
  completed?: boolean,
): string =>
  completed
    ? colors.status.success.main
    : (STATUS_COLORS[status as EvidenceStatus] ?? colors.text.secondary);

/**
 * Ermittelt Label und Farben für einen gegebenen Nachweis-Status
 */
export const getEvidenceStatusVisual = (
  status?: string,
  completed?: boolean,
): StatusVisual => {
  const color = getEvidenceStatusColor(status, completed);
  return {
    label: EVIDENCE_STATUS_LABELS[status as EvidenceStatus] ?? status ?? "",
    color,
    background: `${color}${CHIP_BACKGROUND_ALPHA}`,
  };
};
